// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"297":"99f582c8","643":"f3b59f31"}[chunkId] + ".chunk.js";
};